import * as SharedPermissionsSelectors from './shared-permissions.selector';

export {SharedPermissionsSelectors};
